var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareandpencil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -70.4590 95.9500 70.4590",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.834 0.341797L66.1133 0.341797C76.5137 0.341797 82.3242-5.41992 82.3242-15.8691L82.3242-52.0996C82.3242-62.5488 76.5137-68.3105 66.1133-68.3105L29.834-68.3105C19.4336-68.3105 13.623-62.5488 13.623-52.0996L13.623-15.8691C13.623-5.41992 19.4336 0.341797 29.834 0.341797ZM20.7031-15.8691L20.7031-52.0996C20.7031-57.959 23.9746-61.2793 29.834-61.2793L66.1133-61.2793C71.9727-61.2793 75.2441-57.959 75.2441-52.0996L75.2441-15.8691C75.2441-10.0098 71.9727-6.68945 66.1133-6.68945L29.834-6.68945C23.9746-6.68945 20.7031-10.0098 20.7031-15.8691Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6016-18.8477L50.6348-22.7539L93.1152-65.332C96.6797-68.8477 96.6797-74.5117 93.1152-78.0762L92.041-79.1504C88.5254-82.6172 82.9102-82.4707 79.3457-78.9551L36.9629-36.5234L32.9102-27.9297C30.3711-22.5586 36.0352-16.5039 41.6016-18.8477Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4043-24.1211L47.4121-27.5391L83.1543-63.2812L77.3926-68.8965L41.6992-33.2031L38.0859-25.4883C37.7441-24.7559 38.5742-23.7793 39.4043-24.1211ZM86.1328-66.2598L89.0625-69.2383C90.3809-70.6543 90.3809-72.7051 89.0625-74.0234L87.9883-75.0977C86.7188-76.3672 84.668-76.2207 83.3984-74.9023L80.4199-71.9727Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareandpencil);
export default __webpack_public_path__ + "static/media/square.and.pencil.be5a7cfcb2a245620b9334b4ab9eef0e.svg";
export { ForwardRef as ReactComponent };